import type { Locale } from '@packages/config';

export const getCmsDataCacheKey = (prefix: string, device: 'web' | 'mob', locale: Locale): string =>
  `${prefix}-${locale}-${device}`;
